import React from 'react';

function Footer() {
  return (
    <footer id="footer" className="footer dark-background">
      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <a href="/" className="logo d-flex align-items-center">
              <span className="sitename">SailorsData</span>
            </a>
            <div className="footer-contact pt-3">
              <p>Plot- 111/1890, Gopal Krishna Nagar</p>
              <p>Ananta Vihar, Pokhariput</p>
              <p>Bhubaneswar, District- Khordha</p>
              <p>State- Odisha, India-751006</p>
              <p className="mt-3"><strong>Phone:</strong> <span>+91 9437788017</span></p>
              <p><strong>Landline:</strong> <span>+91 674 2352291</span></p>
              <p><strong>Email:</strong> <span>admin@sailorsdata.com</span></p>
            </div>
            <div className="social-links d-flex mt-4">
              <a href="/"><i className="bi bi-twitter-x"></i></a>
              <a href="/"><i className="bi bi-facebook"></i></a>
              <a href="/"><i className="bi bi-instagram"></i></a>
              <a href="/"><i className="bi bi-linkedin"></i></a>
            </div>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href={`${process.env.REACT_APP_FRONTEND_PORTAL_URL}/#/verify-email?action=post-a-job`}>Post a Job</a></li>
              <li><a href={`${process.env.REACT_APP_FRONTEND_PORTAL_URL}/#/verify-email?action=upload-cv`}>Upload CV</a></li>
              <li><a href="/terms-of-service">Terms of service</a></li>
              <li><a href="/privacy-policy">Privacy policy</a></li>
            </ul>
          </div>

          <div className="col-lg-4 col-md-12 footer-newsletter">
            <h4>Our Newsletter</h4>
            <p>Subscribe to our newsletter and receive the latest news about our products and services!</p>
            <form onSubmit={(e) => e.preventDefault()} className="php-email-form">
              <div className="newsletter-form">
                <input type="email" name="email" />
                <input type="submit" value="Subscribe" />
              </div>
              {/* <div className="loading">Loading</div>
              <div className="error-message"></div>
              <div className="sent-message">Your subscription request has been sent. Thank you!</div> */}
            </form>
          </div>
        </div>
      </div>

      <div className="container copyright text-center mt-4">
        <p>
          © {new Date().getFullYear()} <span>Copyright</span> <strong className="px-1 sitename">SailorsData</strong> <span>All Rights Reserved</span>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
